import { TitleCasePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material";
import { PushNotificationsService } from "@app/main/content/push-notifications/push-notifications.service";
import { FuseSplashScreenService } from "@fuse/services/splash-screen.service";

@Component({
  selector: "app-push-notifications",
  templateUrl: "./push-notifications.component.html",
  styleUrls: ["./push-notifications.component.scss"],
})
export class PushNotificationsComponent implements OnInit {
  form: FormGroup;
  formErrors: any;

  constructor(
    private formBuilder: FormBuilder,
    private _fuseSplashScreenService: FuseSplashScreenService,
    public _pushNotificationsService: PushNotificationsService,
    private snackBar: MatSnackBar
  ) {
    // Reactive form errors
    this.formErrors = {
      subject: {},
      message: {},
    };
  }

  ngOnInit() {
    // Reactive Form
    this.form = this.formBuilder.group({
      subject: ["", Validators.required],
      message: ["", Validators.required],
    });
  }

  onSubmit() {
    // this._fuseSplashScreenService.show();
    const notification = {
      subject: this.form.value.subject,
      message: this.form.value.message,
    };

    const selectedMenuItem = this._pushNotificationsService.selectedMenuItem
      ? this._pushNotificationsService.selectedMenuItem
      : { value: "all" };

    if (selectedMenuItem.value === "all") {
      this._pushNotificationsService.notifyAll(notification).then(() => {
        this.snackBar.open("Your message has been sent successfully!", null, {
          verticalPosition: "top",
          duration: 2000,
        });
        this._fuseSplashScreenService.hide();
      });
    } else if (
      selectedMenuItem &&
      !selectedMenuItem.type &&
      selectedMenuItem.players &&
      selectedMenuItem.players.length !== 0
    ) {
      this._pushNotificationsService
        .sendNotification(selectedMenuItem.players, notification)
        .then((res) => {
          this.snackBar.open("Your message has been sent successfully!", null, {
            verticalPosition: "top",
            duration: 2000,
          });
          this._fuseSplashScreenService.hide();
        });
    } else if (
      selectedMenuItem.type &&
      selectedMenuItem.type === "private game" &&
      selectedMenuItem.players &&
      selectedMenuItem.players.length !== 0
    ) {
      this._pushNotificationsService
        .sendNotification(selectedMenuItem.players, notification)
        .then((res) => {
          this.snackBar.open("Your message has been sent successfully!", null, {
            verticalPosition: "top",
            duration: 2000,
          });
          this._fuseSplashScreenService.hide();
        });
    } else {
      this.snackBar.open(
        `The selected option has no players. Please select send to all options and try again.`,
        null,
        {
          verticalPosition: "top",
          duration: 4000,
        }
      );
      this._fuseSplashScreenService.hide();
    }
  }
}
